import Paragraph from '@editorjs/paragraph';
import type { ToolboxConfig } from '@editorjs/editorjs';

import { PARAGRAPH_SANITIZE } from '../sanitize-config';

// Example tool: thin subclass of EditorJS's Paragraph used for content the
// editor wants tagged as an example. Only the toolbox metadata differs from
// the base Paragraph; the persistent leaf style ('example') is recovered by
// the cluster's save adapter from block.type.
export class ExampleTool extends Paragraph {
  static get pasteConfig(): false {
    return false;
  }

  static get sanitize() {
    return PARAGRAPH_SANITIZE;
  }

  // Enter inserts a line break within the block instead of splitting into a
  // new block — new blocks are only created via the Add-block menu.
  static get enableLineBreaks(): boolean {
    return true;
  }

  static get toolbox(): ToolboxConfig {
    return {
      title: 'Example',
      icon:
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +
        '<circle cx="12" cy="12" r="10"/>' +
        '<line x1="12" y1="16" x2="12" y2="12"/>' +
        '<line x1="12" y1="8" x2="12.01" y2="8"/>' +
        '</svg>',
    };
  }
}
